import request from '@/utils/request'

// 获取骨料限制车数
export function getAllowOne(data) {
  return request.get('/projectConfig/list')
}

// 更新骨料限制车数
export function updateAllowOne(data) {
  return request.post('/projectConfig/update', data)
}

// 获取骨料货车当前车数
export function getCurrentOne(data) {
  return request.get('/truckAccess/exitCar')
}

// 更新当前骨料货车车数
export function updateCurrentOne(params) {
  return request.get('/truckAccess/setExistCar', {
    params
  })
}

